import React from "react";
import { GraphqlClientSettings } from "../GraphqlSettingsPage";

export const fromLocalStorage = (localStorageKey) => {
  return JSON.parse(
    localStorage.getItem(localStorageKey) || "{}",
  ) as GraphqlClientSettings;
};

export const useStateWithLocalStorage = (localStorageKey: string) => {
  const [value, setStateValue] = React.useState<any>(
    fromLocalStorage(localStorageKey),
  );

  const setValue = (setter: (oldValue: any) => void) => {
    // Always update current state value to allow editing from different components
    setStateValue(setter(fromLocalStorage(localStorageKey)));
  };

  React.useEffect(() => {
    localStorage.setItem(localStorageKey, JSON.stringify(value || {}));
  }, [value]);

  return [value, setValue];
};
